import { api } from "aldoo-ra/API"
import { showNotification } from "../../../Notification"

const cmsAPI = api("cms")
export default function DependencyResolver() {
  const computeDependencies = async (target) => {
    if (!Array.isArray(target)) target = [target]
    //if target is an array of update objects
    target = target.map((item) => ({
      type: item.type.value,
      match: item.query.match,
    }))

    const response = await cmsAPI({
      dependency_list: {
        target,
        summary: true,
        includeTargets: true,
      },
    })

    if (response.error) {
      showNotification({
        message: "There was an error computing dependencies",
        className: "bg-admin_error text-white",
      })
      return
    }

    return response
  }

  return {
    computeDependencies,
  }
}
